import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/translate/localstorage.service';
import { TranslateService } from 'src/app/core/services/translate/translate.service';
import { ButtonWarehouseComponent } from '../../components/returns-portal-components/button-warehouse/button-warehouse.component';
import { Location } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
	selector: 'app-page500',
	standalone: true,
	imports: [
		ButtonWarehouseComponent,
		TranslatePipe
	],
	templateUrl: './page500.component.html',
	styleUrl: './page500.component.scss'
})
export class Page500Component {
	public router = inject( Router );
	public localService = inject( LocalStorageService );
	public ts = inject( TranslateService );
	public location = inject( Location );

	goBack(): void {
		this.location.back();
	}
	tryToLogin(){
		this.router.navigateByUrl('auth/login')
	}
}
